import React from 'react'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import Icon from 'Pods/Shared/Icon/Icon'
import Progressbar from 'Pods/Shared/Progressbar'

function UserModelsRating({ positiveRates, negativeRates, locale }) {
  const ratings = i18n.t('profilePage.ratings', { ns: 'rails', lng: locale })

  return (
    <div className="user-reviews__rating">
      <span className="message__rating-subtitle u-mr10">
        {ratings}:
      </span>
      <div className="product-ratings">
        <span className="product-ratings__thumbs">
          <span>
            <Icon type="thumbs-up" color="green-dark" />
            {positiveRates}
          </span>
          <span>
            <Icon type="thumbs-down" color="grey" />
            {negativeRates}
          </span>
        </span>
        <div className="product-ratings__bar">
          <Progressbar
            value={positiveRates}
            maxValue={positiveRates + negativeRates}
            labelSize="label-none"
            barColor="is-dark"
          />
        </div>
      </div>
    </div>
  )
}

UserModelsRating.propTypes = {
  positiveRates: PropTypes.number.isRequired,
  negativeRates: PropTypes.number.isRequired,
}

export default UserModelsRating
